<template>
  <Transition mode='out-in'>
    <div id='loading-div'>
      <div v-if='visible' class='container'>

        <button @click='viewBack' class='btn btn-orange btn-block w-auto px-5' type='button'>
          Wróć
        </button>

        <div class='row'>
          <div class='col-lg'>
            <div class='section-title'>Informacje o pracowniku</div>
            <table class='table'>
              <tr>
                <td class='col1'>Imię i nazwisko</td>
                <td>{{ this.details.name }} {{ this.details.surname }}</td>
              </tr>
              <tr>
                <td class='col1'>E-mail</td>
                <td>{{ this.details.login }}@lekseek.com</td>
              </tr>
              <tr>
                <td class='col1'>Opiekun</td>
                <td>{{ this.details.supervisor }}</td>
              </tr>
              <tr>
                <td class='col1'>Dział</td>
                <td>{{ areaFilter }}</td>
              </tr>
              <tr>
                <td class='col1'>Projekt</td>
                <td>{{ getProject() }}</td>
              </tr>
              <tr>
                <td class='col1'>Godziny <br />(obecny miesiąc)</td>
                <td>{{ getCurrentMonthWorktime() }}</td>
              </tr>
              <tr>
                <td class='col1'>Godziny <br />(poprzedni miesiąc)</td>
                <td>{{ getPreviousMonthWorktime() }}</td>
              </tr>
              <tr>
                <td class='col1'>Średnia godzin <br />(3 miesiące)</td>
                <td>{{ getThreeMonthAverageWorktime() }}</td>
              </tr>
              <tr>
                <td class='col1'>Średnia godzin <br />(dzienna)</td>
                <td>{{ getDailyAverageWorktime() }}</td>
              </tr>
            </table>
          </div>

          <div v-if='showGitSection' class='col-lg'>
            <EmployeeGitStatus :gitlabSummary='gitlabSummary' />
          </div>

        </div>
      </div>
    </div>
  </Transition>
</template>

<script>
import { backend } from '../../backend.js';
import moment from 'moment';
import EmployeeGitStatus from './EmployeeGitStatus.vue';

moment.locale('pl');

export default {
  name: 'EmployeeDetails',
  components: {
    EmployeeGitStatus,
  },
  props: ['details', 'areas', 'projects'],
  data: function () {
    return {
      visible: false,
      remoteUser: {},
      worktime: {},
      gitlabSummary: {}
    }
  },
  computed: {
    areaFilter() {
      const area = this.areas.find(area => area.id === this.details.area);
      return area ? area.name : undefined;
    },
    showGitSection() {
      return this.gitlabSummary.username && (this.gitlabSummary.latest_merged.length || this.gitlabSummary.latest_events.length)
    }
  },
  created: function () {
    backend.getEmployeeDetailsWorktime(this.details.id).then((response) => {
      this.worktime = response.data;
    });
    backend.getGitlabUserSummary(this.details.login).then((response) => {
      this.gitlabSummary = response.data;
    }).catch(() => {
      console.log('Błąd podczas pobierania danych o użytkowniku z GitLaba.');
    }).finally(() => {
      this.$vs.loading.close('#loading-div > .con-vs-loading')
      this.visible = true;
    });
    backend.getRemoteUsers().then(response => {
      const data = response.data;
      this.remoteUser = data.find(user => user.id === this.details.id);
    });
  },
  mounted: function () {
    this.$vs.loading({ container: '#loading-div', scale: 1 });
  },
  methods: {
    viewBack: function () {
      this.$emit('changeDetail', { component_change: 'employee-list', details: null });
    },
    getConvertedDate(date) {
      return moment(date).format('DD/MM/YYYY HH:mm:ss');
    },
    getEventType(item) {
      return item.target_type || 'Brak';
    },
    getEventTitle(item) {
      return item.target_title || (item.push_data || {}).commit_title || 'Brak';
    },
    getEventRef(item) {
      return (item.push_data || {}).ref || 'Brak';
    },
    getProject() {
      const project = this.projects.find(project => project.id === this.remoteUser.project);
      return project ? project.name : 'Brak';
    },
    getCurrentMonthWorktime() {
      return (this.worktime.current_month / 60).toFixed(2)
    },
    getPreviousMonthWorktime() {
      return (this.worktime.previous_month / 60).toFixed(2)
    },
    getThreeMonthAverageWorktime() {
      return (this.worktime.monthly_average / 60).toFixed(2)
    },
    getDailyAverageWorktime() {
      return (this.worktime.daily_average / 60).toFixed(2)
    }
  }
};
</script>

<style scoped>
.section-title {
  font-size: 1.75rem;
  font-weight: 700;
  text-align: center;
  color: #212529;
}

table td {
  border-width: 0px;
  padding: 0.5rem;
}

.col1 {
  text-align: right;
  font-weight: 700;
}
</style>


// WEBPACK FOOTER //
// EmployeeDetails.vue?1f7ed906